<template>
  <div id="main">
    <navbar-logined />
    <div id="body">
      <slot :nuxt-child-key="$route.fullPath" />
    </div>
    <footer-component />

    <password-modal />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarLogined from '~/components/NavbarLogined.vue';
import FooterComponent from '~/components/Footer.vue';
import PasswordModal from '~/components/PasswordModal.vue';

export default defineComponent({
  components: {
    NavbarLogined,
    FooterComponent,
    PasswordModal
  },
  middleware: [
    'auth',
    'user',
    'redirectProfileNecessaryItemEditPage',
    'sentryContext',
    'i18n'
  ],
  data() {
    return {};
  }
});
</script>

<style lang="scss" scoped>
#main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}

#body {
  margin-bottom: 100px;
}
</style>
